module.exports = __webpack_public_path__ + "static/media/chat.5c40e373.svg";